import React from "react"
import {matchSorter} from 'match-sorter'
import alimento_gen from "../images/alimento_gen.svg"
import IAlimento from "../interfaces/IAlimento"
import IAlarma from "../interfaces/IAlarma"
import db from "./Database"
import { get } from "../Rest"
import { IonAvatar, IonBadge, IonButton, IonButtons, IonContent, IonHeader, IonIcon, IonInput, IonItem, IonLabel, IonList, IonModal, IonSearchbar, IonText, IonTitle, IonToolbar } from "@ionic/react"
import { arrowBack, arrowUp, sad, search, trash } from "ionicons/icons"
//https://historiaybiografias.com/calorias/

export default class BuscadorProductos extends React.Component<{onAdd:any}>{

    timeout = {} as any

    state = {
        items: [] as Array<IAlimento>,
        busqueda: "" as string,
        selected: {} as IAlimento,
        alarmas: {} as IAlarma,
        show:false
    }

    buscarChange = async (e:any) => {
        await this.setState({busqueda:e.target.value})
        clearTimeout(this.timeout)
        this.timeout = setTimeout(() => this.buscar(),300)
    }

    buscar = async () => {
        const {busqueda} = this.state
        const items_tmp = await db.alimentos.filter(p => p.estado == "A").toArray()
        const items = matchSorter(items_tmp,busqueda,{keys:["nombre"]})
        await this.setState({items})
    }

    onClick = (selected:IAlimento) => {
        const {onAdd} = this.props
        onAdd(selected)
        this.setState({selected,show:false})
    }

    render(){
        const {items,selected,show,busqueda} = this.state
        return (
        <>
                {
                    selected.id ? (
                     <IonItem >
                         <IonAvatar slot="start"  onClick={() => this.setState({show:true})}>
                            <img src={selected.foto||alimento_gen} />
                        </IonAvatar>
                        <IonLabel  onClick={() => this.setState({show:true})}>
                            <small><b>{selected.porcion}</b></small>
                            <h2>{selected.nombre} </h2>
                            {selected.equivalencia?
                                <p>{selected.equivalencia}</p>
                            :null}
                        </IonLabel>
                        <IonBadge slot="end"  onClick={() => this.setState({show:true})}>{selected.calorias} cal</IonBadge>
                     </IonItem>   
                    ):(
                    <IonItem onClick={() => this.setState({show:true})} >
                        <IonInput readonly placeholder="Buscar alimento.." />
                    </IonItem>
                    )
                }
            <IonModal isOpen={show} onDidDismiss={() => this.setState({show:false})}>
                <IonHeader mode="md">
                    <IonToolbar>
                        <IonButtons slot="start">
                            <IonButton onClick={() => this.setState({show:false})}>
                                <IonIcon icon={arrowBack} />
                            </IonButton>
                        </IonButtons>
                        <IonTitle>Buscador de alimentos</IonTitle>
                    </IonToolbar>
                    <IonToolbar>
                        <IonSearchbar placeholder="Buscar un alimento" onIonChange={this.buscarChange} />
                    </IonToolbar>
                </IonHeader>
                <IonContent>
                    <IonList>
                        {
                            busqueda ?
                            items.length>0?
                                items.map((alimento,i) => (
                                    <IonItem key={i} button onClick={() => this.onClick(alimento)}>
                                        <IonAvatar slot="start">
                                            <img src={alimento.foto||alimento_gen} />
                                        </IonAvatar>
                                        <IonLabel>
                                            <small><b>{alimento.porcion}</b></small>
                                            <h2>{alimento.nombre} </h2>
                                            {alimento.equivalencia?
                                                <p>{alimento.equivalencia}</p>
                                            :null}
                                        </IonLabel>
                                        <IonBadge slot="end">{alimento.calorias} cal</IonBadge>
                                    </IonItem>
                                ))
                            :<IonItem lines="none"><span style={{textAlign:"center"}}><IonIcon icon={sad} /> No existen datos para su búsqueda</span></IonItem>
                            :<IonItem lines="none"><span style={{textAlign:"center"}}><IonIcon icon={arrowUp} /> Busca un alimento en la parte superior</span></IonItem>
                        }
                    </IonList>
                </IonContent>
            </IonModal>
        </>
        )
    }
}
